import request from "./request";

export async function login(data) {
  return await request.post("/spin/sysUser/login", data);
}

export async function isTokenExpire() {
  return await request.get("/spin/sysUser/isTokenExpire");
}

export async function logout(data) {
  return await request.post("/spin/sysUser/logout", data);
}
